// 设备型号常量对象（便于代码中引用）- 按产品类型编号排序
export const sesameDeviceModel = {
  sesame_2: 'sesame_2', // 0
  wm_2: 'wm_2', // 1
  ssmbot_1: 'ssmbot_1', // 2
  bike_1: 'bike_1', // 3
  sesame_4: 'sesame_4', // 4
  sesame_5: 'sesame_5', // 5
  ssm_bike2: 'bike_2', // 6
  sesame_5_pro: 'sesame_5_pro', // 7
  ssm_opensensor_1: 'open_sensor_1', // 8
  ssm_touch_pro: 'ssm_touch_pro', // 9
  ssm_touch: 'ssm_touch', // 10
  ble_connector: 'BLE_Connector_1', // 11
  hub_3: 'hub_3', // 13
  remote: 'remote', // 14
  remote_nano: 'remote_nano', // 15
  sesame_5_us: 'sesame_5_us', // 16
  bot_2: 'bot_2', // 17
  sesame_face_pro: 'sesame_face_Pro', // 18
  sesame_face: 'sesame_face', // 19
  sesame_6: 'sesame_6', // 20
  sesame_6_pro: 'sesame_6_pro', // 21
  sesame_face_pro_ai: 'sesame_face_pro_ai', // 22
  sesame_face_ai: 'sesame_face_ai', // 23
  ssm_opensensor_2: 'open_sensor_2', // 24
  ssm_touch_2: 'ssm_touch_2', // 25
  ssm_touch_2_pro: 'ssm_touch_2_pro', // 26
  sesame_face_2: 'sesame_face_2', // 27
  sesame_face_2_pro: 'ssm_face_2_pro', // 28
  sesame_miwa: 'sesame_miwa', // 29
  sesame_face_2_ai: 'sesame_face_2_ai', // 30
  sesame_face_2_pro_ai: 'sesame_face_2_pro_ai', // 31
  sesame_6_pro_slidingdoor: 'sesame_6_pro_slidingdoor', // 32
  ssm_bike3: 'bike_3', // 33
  bot_3: 'bot_3', // 35
  hub3_pro: 'hub_3_pro', // 36 —— Hub 3 Pro(esp32s31);旧 Hub 3(esp32c3)是上面的 hub_3 // 13
  sesame_face_3: 'sesame_face_3', // 37
};

// 用于根据设备产品类型 ID 获取对应的型号名称
export const modelNameByProductType = {
  0: sesameDeviceModel.sesame_2,
  1: sesameDeviceModel.wm_2,
  2: sesameDeviceModel.ssmbot_1,
  3: sesameDeviceModel.bike_1,
  4: sesameDeviceModel.sesame_4,
  5: sesameDeviceModel.sesame_5,
  6: sesameDeviceModel.ssm_bike2,
  7: sesameDeviceModel.sesame_5_pro,
  8: sesameDeviceModel.ssm_opensensor_1,
  9: sesameDeviceModel.ssm_touch_pro,
  10: sesameDeviceModel.ssm_touch,
  11: sesameDeviceModel.ble_connector,
  13: sesameDeviceModel.hub_3,
  14: sesameDeviceModel.remote,
  15: sesameDeviceModel.remote_nano,
  16: sesameDeviceModel.sesame_5_us,
  17: sesameDeviceModel.bot_2,
  18: sesameDeviceModel.sesame_face_pro,
  19: sesameDeviceModel.sesame_face,
  20: sesameDeviceModel.sesame_6,
  21: sesameDeviceModel.sesame_6_pro,
  22: sesameDeviceModel.sesame_face_pro_ai,
  23: sesameDeviceModel.sesame_face_ai,
  24: sesameDeviceModel.ssm_opensensor_2,
  25: sesameDeviceModel.ssm_touch_2,
  26: sesameDeviceModel.ssm_touch_2_pro,
  27: sesameDeviceModel.sesame_face_2,
  28: sesameDeviceModel.sesame_face_2_pro,
  29: sesameDeviceModel.sesame_miwa,
  30: sesameDeviceModel.sesame_face_2_ai,
  31: sesameDeviceModel.sesame_face_2_pro_ai,
  32: sesameDeviceModel.sesame_6_pro_slidingdoor,
  33: sesameDeviceModel.ssm_bike3,
  35: sesameDeviceModel.bot_3,
  36: sesameDeviceModel.hub3_pro,
  37: sesameDeviceModel.sesame_face_3,
};

// 设备型号对应的显示名称（与设备端 deviceModelName 保持一致），仅用于页面展示
const displayNameByModel = {
  [sesameDeviceModel.sesame_2]: 'Sesame 3',
  [sesameDeviceModel.wm_2]: 'WiFi Module 2',
  [sesameDeviceModel.ssmbot_1]: 'Sesame Bot 1',
  [sesameDeviceModel.bike_1]: 'Sesame Bike 1',
  [sesameDeviceModel.sesame_4]: 'Sesame 4',
  [sesameDeviceModel.sesame_5]: 'Sesame 5',
  [sesameDeviceModel.ssm_bike2]: 'Sesame Bike 2',
  [sesameDeviceModel.sesame_5_pro]: 'Sesame 5 Pro',
  [sesameDeviceModel.ssm_opensensor_1]: 'Open Sensor 1',
  [sesameDeviceModel.ssm_touch_pro]: 'Sesame Touch 1 Pro',
  [sesameDeviceModel.ssm_touch]: 'Sesame Touch 1',
  [sesameDeviceModel.ble_connector]: 'BLE Connector 1',
  [sesameDeviceModel.hub_3]: 'Hub 3',
  [sesameDeviceModel.remote]: 'Remote',
  [sesameDeviceModel.remote_nano]: 'Remote Nano',
  [sesameDeviceModel.sesame_5_us]: 'Sesame 5 US',
  [sesameDeviceModel.bot_2]: 'Sesame Bot 2',
  [sesameDeviceModel.sesame_face_pro]: 'Sesame Face 1 Pro',
  [sesameDeviceModel.sesame_face]: 'Sesame Face 1',
  [sesameDeviceModel.sesame_6]: 'Sesame 6',
  [sesameDeviceModel.sesame_6_pro]: 'Sesame 6 Pro',
  [sesameDeviceModel.sesame_face_pro_ai]: 'Sesame Face 1 Pro AI',
  [sesameDeviceModel.sesame_face_ai]: 'Sesame Face 1 AI',
  [sesameDeviceModel.ssm_opensensor_2]: 'Open Sensor 2',
  [sesameDeviceModel.ssm_touch_2]: 'Sesame Touch 2',
  [sesameDeviceModel.ssm_touch_2_pro]: 'Sesame Touch 2 Pro',
  [sesameDeviceModel.sesame_face_2]: 'Sesame Face 2',
  [sesameDeviceModel.sesame_face_2_pro]: 'Sesame Face 2 Pro',
  [sesameDeviceModel.sesame_miwa]: 'Sesame miwa',
  [sesameDeviceModel.sesame_face_2_ai]: 'Sesame Face 2 AI',
  [sesameDeviceModel.sesame_face_2_pro_ai]: 'Sesame Face 2 Pro AI',
  [sesameDeviceModel.sesame_6_pro_slidingdoor]: 'Sesame 6 Pro SlidingDoor',
  [sesameDeviceModel.ssm_bike3]: 'Sesame Bike 3',
  [sesameDeviceModel.bot_3]: 'Sesame Bot 3',
  [sesameDeviceModel.hub3_pro]: 'Hub 3 Pro',
  [sesameDeviceModel.sesame_face_3]: 'Sesame Face 3',
};

// 未收录的型号回退显示原始 deviceModel
export const deviceModelDisplayName = (model) => displayNameByModel[model] || model;
